import React from 'react';
import PropTypes from 'prop-types';

const Progress = ({ progressLabel, progressComplete }) => {
	const progressOuterStyle = {
		margin: '10px auto 20px'
	};

	const progressContainerStyle = {
		width: '60%',
		height: '6px',
		boxShadow: 'none',
		backgroundColor: 'var(--color-neutral-100)',
		margin: '0px auto'
	};

	const progressStatusStyle = {
		width: `${progressComplete}%`,
		backgroundColor: 'var(--color-success-500)'
	};

	return (
		<div style={progressOuterStyle}>
			<div className="progress rounded" style={progressContainerStyle}>
				<div
					className="progress-bar"
					role="progressbar"
					aria-label={progressLabel}
					aria-valuenow={progressComplete}
					aria-valuemin="0"
					aria-valuemax="100"
					style={progressStatusStyle}
				/>
			</div>
			<span className="ddc-font-size-xsmall text-muted">
				{progressLabel}
			</span>
		</div>
	);
};

Progress.propTypes = {
	progressLabel: PropTypes.string,
	progressComplete: PropTypes.number
};

export default Progress;
